module.exports = __webpack_public_path__ + "static/img/agb_1.b30ab7c.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/agb_1.png
// module id = 1242
// module chunks = 1